import { render, staticRenderFns } from "./test.vue?vue&type=template&id=96a8a97e&scoped=true&"
import script from "./test.vue?vue&type=script&lang=js&"
export * from "./test.vue?vue&type=script&lang=js&"
import style0 from "./test.vue?vue&type=style&index=0&id=96a8a97e&scoped=true&lang=less&"
import style1 from "./test.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a8a97e",
  null
  
)

export default component.exports